import * as Sentry from '@sentry/react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { remove } from 'redux/slices/user';

import { apiWrapper } from 'config/api';
import { navigationUrls } from 'navigation/routes';

import { ISignIn } from 'types/models/Auth';

/** Хук вызова удаления стора и хеадеров API запросов */
export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return () => {
    const auth: ISignIn = {
      'access-token': '',
      client: '',
      uid: ''
    };

    // Удаляем данные стора
    dispatch(remove());

    // Очищаем headers
    apiWrapper.addRequestTransform((request) => {
      request.headers = { ...auth };
    });

    // Очищаем пользователя в Sentry
    Sentry.setUser(null);

    // Делаем редирект на страницу авторизации
    navigate(navigationUrls.auth.login);
  };
};
